// extracted by mini-css-extract-plugin
module.exports = {"link":"_2yeWks","links":"_3LSW8e"};